export default __webpack_public_path__ + "static/char-s-14-en-9b4de19817e751bb4d7251ef857c2e0a.webp";